import React, { useState, useEffect } from "react";
import { db } from "../../utils/firebase";
import { collection, getDocs, doc, setDoc, deleteDoc, getDoc } from "firebase/firestore"; // Firestore methods
import Navbar from "../navbar/Navbar";
import Footer from "../footer/Footer";
import { Link, useLocation } from 'react-router-dom';
import './AdminFeedback.css'; // Custom styles

const AdminFeedback = () => {
  const [feedbacks, setFeedbacks] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  // Fetch feedback data from Firestore
  useEffect(() => {
    const fetchFeedbacks = async () => {
      try {
        const feedbackCollectionRef = collection(db, "feedback");
        const snapshot = await getDocs(feedbackCollectionRef);

        if (!snapshot.empty) {
          const feedbackData = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));

          setFeedbacks(feedbackData);
        } else {
          console.log("No feedback found in the database.");
        }
      } catch (error) {
        console.error("Error fetching feedbacks:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFeedbacks();
  }, []);

  const handleDeleteFeedback = async (feedbackId) => {
    try {
      // Fetch the feedback data
      const feedbackRef = doc(db, "feedback", feedbackId);
      const feedbackSnap = await getDoc(feedbackRef);

      if (feedbackSnap.exists()) {
        const feedbackData = feedbackSnap.data();

        // Move feedback data to feedback_archive collection
        await setDoc(doc(db, "feedback_archive", feedbackId), feedbackData);

        // Delete feedback from feedback collection
        await deleteDoc(feedbackRef);

        // Update the local state by removing the deleted feedback
        setFeedbacks((prevFeedbacks) =>
          prevFeedbacks.filter((feedback) => feedback.id !== feedbackId)
        );

        console.log(`Feedback ${feedbackId} archived and deleted.`);
      } else {
        console.error("Feedback not found.");
      }
    } catch (error) {
      console.error("Error deleting feedback:", error);
    }
  };

  if (loading) return <p>Loading feedback...</p>;

  return (
    <div className="admin-page">
      <Navbar />
      <div className="admin-container">
      <div className="admin-sidebar">

          <h2>Admin Panel</h2>
          <Link to="/adminusers" className={`sidebar-button ${location.pathname === '/adminusers' ? 'active' : ''}`}>Users</Link>
          <Link to="/adminposts" className={`sidebar-button ${location.pathname === '/adminposts' ? 'active' : ''}`}>User Posts</Link>
          <Link to="/adminfeedback" className={`sidebar-button ${location.pathname === '/adminfeedback' ? 'active' : ''}`}>User Feedback</Link>
          <Link to="/announcementadmin" className={`sidebar-button ${location.pathname === '/announcementadmin' ? 'active' : ''}`}>Announcements</Link>
          <Link to="/exploreaboutadmin" className={`sidebar-button ${location.pathname === '/exploreaboutadmin' ? 'active' : ''}`}>Explore about Bacoor</Link>

          <h2>Places to Visit</h2>
          <Link to="/bridgesadmin" className={`sidebar-button ${location.pathname === '/bridgesadmin' ? 'active' : ''}`}>Bridges & Dams</Link>
          <Link to="/monumentsadmin" className={`sidebar-button ${location.pathname === '/monumentsadmin' ? 'active' : ''}`}>Monuments & Statues</Link>
          <Link to="/houseadmin" className={`sidebar-button ${location.pathname === '/houseadmin' ? 'active' : ''}`}>Ancestral Houses</Link>
          <Link to="/churchesadmin" className={`sidebar-button ${location.pathname === '/churchesadmin' ? 'active' : ''}`}>Churches & Religious Sites</Link>

          <h2>Things to Do</h2>
          <Link to="/recreationaladmin" className={`sidebar-button ${location.pathname === '/recreationaladmin' ? 'active' : ''}`}>Recreational Activities</Link>
          <Link to="/diningadmin" className={`sidebar-button ${location.pathname === '/diningadmin' ? 'active' : ''}`}>Dining and Culinary</Link>
          <Link to="/shoppingadmin" className={`sidebar-button ${location.pathname === '/shoppingadmin' ? 'active' : ''}`}>Shopping and Market</Link>

          <h2>Archives</h2>
          <Link to="/userarchive" className={`sidebar-button ${location.pathname === '/userarchive' ? 'active' : ''}`}>Users</Link>
          <Link to="/postsarchive" className={`sidebar-button ${location.pathname === '/postsarchive' ? 'active' : ''}`}>Posts</Link>
          <Link to="/feedbackarchive" className={`sidebar-button ${location.pathname === '/feedbackarchive' ? 'active' : ''}`}>Feedback</Link>
          <Link to="/announcementarchive" className={`sidebar-button ${location.pathname === '/announcementarchive' ? 'active' : ''}`}>Announcements</Link>
        </div>
        <div className="admin-content">
          <h2>User Feedback</h2>
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>Category</th>
                  <th>Date Created</th>
                  <th>Feedback</th>
                  <th>File</th>
                  <th>Rating</th>
                  <th>User ID</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {feedbacks.map((feedback) => (
                  <tr key={feedback.id}>
                    <td>{feedback.category || "N/A"}</td>
                    <td>{feedback.createdAt ? new Date(feedback.createdAt.seconds * 1000).toLocaleString() : "N/A"}</td>
                    <td>{feedback.feedback || "No feedback provided"}</td>
                    <td>{feedback.fileUrl ? <a href={feedback.fileUrl} target="_blank" rel="noopener noreferrer">View File</a> : "No file"}</td>
                    <td>{feedback.rating || "N/A"}</td>
                    <td>{feedback.userId || "Unknown"}</td>
                    <td>
                      <button 
                        className="delete-btn"
                        onClick={() => handleDeleteFeedback(feedback.id)}
                      >
                       <i className="bi bi-trash"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AdminFeedback;
